import React from 'react';
import ReactDOM from 'react-dom';
import './css/sharedStyles.css';
import App from './components/App';
import registerServiceWorker from './registerServiceWorker';

import { BrowserRouter, Route, browserHistory, Switch} from "react-router-dom";
import { createStore, combineReducers, applyMiddleware} from "redux";
import logger from "redux-logger";

//this is a dumb hack bc this React bg image path thing is driving me nuts
import "./components/includes/behindTheScenes/body_bgImage_hack.js";

//react-redux is the bridge so React knows how to access the redux store
import {Provider} from "react-redux";


import {menuReducer} from './reducers/menuReducer.js';
import {characterPageReducer} from './reducers/characterPageReducer.js';
import {comicPageReducer} from './reducers/comicPageReducer.js';
import {characterDatabaseReducer} from './reducers/characterDatabaseReducer.js';
import {comicDatabaseReducer} from './reducers/comicDatabaseReducer.js';
import {paginationReducer} from './reducers/paginationReducer.js';
import {videoReducer} from './reducers/videoReducer.js';

////right away gernerate the marvel key hash and store it in local storage
////for the rest of the app to access
import {generateMarvelKey} from "./components/includes/behindTheScenes/marvelKey.js";
generateMarvelKey();


////create a store made of all required reducers. 
////the reducers will declare the functions that will be called down the chain, updating the store
const store = createStore(combineReducers({
    menuReducer:menuReducer,
    characterPageReducer:characterPageReducer,
    comicPageReducer:comicPageReducer,
    characterDatabaseReducer:characterDatabaseReducer,
    paginationReducer:paginationReducer,
    comicDatabaseReducer:comicDatabaseReducer,
    videoReducer:videoReducer
    }),
    {} ,
    //applyMiddleware(logger)
);

ReactDOM.render(
    <BrowserRouter>    
        <Provider store={store}>
        <App/> 
        </Provider>
    </BrowserRouter>,
    document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js